export function invitationPasswordUpdateRequest(newPassword: string): {
  newPassword: string;
  signOutOfOtherSessions: true;
} {
  return { newPassword, signOutOfOtherSessions: true };
}

export function apiErrorCode(error: unknown): string | null {
  if (!error || typeof error !== "object" || !("detail" in error)) return null;
  const detail = (error as { detail?: unknown }).detail;
  if (!detail || typeof detail !== "object" || !("code" in detail)) return null;
  const code = (detail as { code?: unknown }).code;
  return typeof code === "string" ? code : null;
}

export function clerkErrorCode(error: unknown): string | null {
  if (!error || typeof error !== "object" || !("errors" in error)) return null;
  const errors = (error as { errors?: unknown }).errors;
  if (!Array.isArray(errors)) return null;
  const first = errors[0];
  if (!first || typeof first !== "object" || !("code" in first)) return null;
  const code = (first as { code?: unknown }).code;
  return typeof code === "string" ? code : null;
}

export function passwordValidationProblem(password: string, passwordAgain: string): string | null {
  if (password.length < 8) return "Use at least 8 characters for your password.";
  if (password !== passwordAgain) return "Those passwords do not match.";
  return null;
}

export function invitationLookupProblem(code: string | null): { title: string; body: string } {
  if (code === "identity_maintenance") {
    return { title: "Login update in progress", body: "Try this link again in a minute." };
  }
  if (code === "invitation_expired") {
    return {
      title: "This invitation expired",
      body: "Ask the person who invited you to send a new link.",
    };
  }
  if (code === "invitation_revoked") {
    return {
      title: "This invitation was canceled",
      body: "Ask the person who invited you if you still need access.",
    };
  }
  if (code === "invitation_used" || code === "invitation_accepted") {
    return {
      title: "This invitation was already used",
      body: "Sign in with the account you created, or ask for a new link.",
    };
  }
  if (code === "invitation_check_failed") {
    return { title: "We couldn't check this invitation", body: "Try this link again in a minute." };
  }
  return {
    title: "This invitation is not available",
    body: "Ask the person who invited you to send a new link.",
  };
}

export function passwordSetupProblem(code: string | null): string {
  if (code === "reverification_cancelled") {
    return "We did not save your password. Try again when you're ready.";
  }
  if (code?.startsWith("form_password_") === true || code === "password_pwned") {
    return "Use a stronger password. Try a longer mix of words, numbers, and symbols.";
  }
  return "We couldn't save your password. Try again.";
}
